// extracted by mini-css-extract-plugin
export default {"container":"BusyIndicator_container__15bYj","fullScreen":"BusyIndicator_fullScreen__hQkrm","text":"BusyIndicator_text__YGaso"};